// Intent-time preload seam for chat-side modules. Fire-and-forget; FG-gated; once per page load.
import { fg } from '@atlaskit/platform-feature-flags';
import { preloadLazyCardWithUrlContent } from '@atlaskit/smart-card/preload-lazy-card-with-url-content';
import { importAutoSuggest } from '@atlassian/conversation-assistant-auto-suggest/import-auto-suggest';

import { importFeedbackFlag } from './ui/feedback-collector/feedback-flag/import-feedback-flag';
import { importSmartCreationWrapper } from './ui/smart-creation-wrapper/import-smart-creation-wrapper';

let hasPreloadedChatOnIntent = false;

function preloadSmartCard(): void {
	void preloadLazyCardWithUrlContent().catch(() => {});
}

function preloadAutoSuggest(): void {
	void importAutoSuggest().catch(() => {});
}

function preloadSmartCreationWrapper(): void {
	void importSmartCreationWrapper().catch(() => {});
}

function preloadFeedbackFlag(): void {
	void importFeedbackFlag().catch(() => {});
}

export function preloadChatOnIntent(): void {
	if (typeof window === 'undefined' || !fg('chat_preload_components')) {
		return;
	}

	if (hasPreloadedChatOnIntent) {
		return;
	}

	hasPreloadedChatOnIntent = true;

	preloadSmartCard();
	preloadAutoSuggest();
	preloadSmartCreationWrapper();
	preloadFeedbackFlag();
}
